<template>
  <DialogDrawer ref="dialog" modal placement="centre" @close="$emit('close')" @submit="submit">
    <template #title>Add {{ title }}</template>
    <div class="flex-grow-1 overflow-x-visible overflow-y-auto h-100 border rounded p-2">
      <div v-if="unselectedOptions.length !== 0">
        <div v-for="(option, index) in unselectedOptions" :key="index" class="form-check">
          <input
            :id="`addOnCheckbox-${option.id}`"
            v-model="checkedIdsModel"
            class="form-check-input"
            :value="option.id"
            type="checkbox"
            true-value="yes"
            false-value="no"
          />
          <label class="form-check-label" :for="`addOnCheckbox-${option.id}`">
            {{ option.name }}
          </label>
        </div>
      </div>
      <div v-else>
        <span class="text-center">No {{ title }} available</span>
      </div>
    </div>
    <template #buttons>
      <BootstrapButton name="cancel" variant="ghost" formmethod="dialog" @click="$emit('close')">
        Cancel
      </BootstrapButton>
      <BootstrapButton
        name="submit"
        type="submit"
        variant="primary"
        :disabled="loading || options.length < 1"
        :loading="loading"
      >
        Add
      </BootstrapButton>
    </template>
  </DialogDrawer>
</template>
<script lang="ts" setup>
import {
  LaborComponent,
  ProductComponent,
  ServiceLevelObjective,
  MappedFeatureLink,
  Feature,
} from '@/stores/userManagement/userManagement';
import DialogDrawer from '@/components/shared/custom/DialogDrawer/DialogDrawer.vue';

type OfferingAddOns =
  | MappedFeatureLink[]
  | ProductComponent[]
  | LaborComponent[]
  | ServiceLevelObjective[];

const props = defineProps<{
  title: string;
  items: OfferingAddOns | Feature[];
  selectedItems: OfferingAddOns;
  open: boolean;
  loading?: boolean;
}>();

const emit = defineEmits<{
  (event: 'close'): void;
  (event: 'submit', items: OfferingAddOns): void;
}>();

const dialog = useTemplateRef<InstanceType<typeof DialogDrawer>>('dialog');
const checkedIdsModel = ref<number[]>([]);

const options = computed(() => props.items || []);
const selectedOptions = computed(() => props.selectedItems || []);

const unselectedOptions = computed(() => {
  return options.value.filter((o) => {
    return !selectedOptions.value.find((so) => o.id === so.id);
  });
});

const submit = () => {
  if (checkedIdsModel.value.length === 0) emit('close');
  else {
    const items = checkedIdsModel.value.map((id) => {
      const item = props.items.find((c) => id === c.id);
      if (item === undefined) throw Error("Couldn't find checked item");
      return item;
    }) as OfferingAddOns;
    emit('submit', items);
  }
};

watch(
  () => props.open,
  (newOpen) => {
    if (newOpen) {
      dialog.value?.openModal();
    } else {
      dialog.value?.close();
      checkedIdsModel.value = [];
    }
  },
);
</script>
